import * as React from 'react';
import styled from 'styled-components';
import { Colors, transparentize } from '..';

interface LoadingStateProps {
	text: string;
}

export default function LoadingOverlay(props: LoadingStateProps) {
	const { text } = props;
	return (
		<Container>
			<i className="fas fa-spinner fa-pulse fa-fw fa-lg mb-2"></i>
			<span>{text}</span>
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: absolute;
	inset: 0;
	z-index: 1;

	background: ${transparentize(Colors.white, 0.3)};
`;
